/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	MediaImageUploadPathParams,
	MediaImageUploadRequest,
	MediaImageUploadResponse,
} from '../types/MediaImageUpload'
import { buildFormData } from '../utils/form-data'

/**
 * POST /media/:organisation/images
 * @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::upload
 */
export async function mediaImageUpload(
	organisation: MediaImageUploadPathParams['organisation'],
	data: MediaImageUploadRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MediaImageUploadResponse>> {
	return axiosInstance.post(`/media/${organisation}/images`, buildFormData(data), {
		headers: { 'Content-Type': 'multipart/form-data' },
		...config,
	})
}
